import React, {createContext, useReducer} from "react";
import {ContainerDetailReducer} from "../reducers/ContainerDetailReducer";

export const ContainerDetailContext = createContext();

const ContainerContextProvider = (props) => {
    const lineHaulContainerDetails = {
        lineHaulList: [],
        containerDetail: {},
        expandableCells: []
    }
    const [viewModel, dispatch ] = useReducer(ContainerDetailReducer, lineHaulContainerDetails)
    return (
        <ContainerDetailContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </ContainerDetailContext.Provider>
    )
}

export default ContainerContextProvider


// WEBPACK FOOTER //
// ./src/components/induct/context/ContainerContext.js